import { ButtonContainer, ButtonLoaderImage, ButtonText } from '../../styles';
import {
  PrimaryButton,
  SecondaryButton,
} from '@acko-tech/building-blocks.ui.button';
import { ASSETS } from 'src/common/utils/config';
import parse from 'html-react-parser';

const Index = ({
  isLoading = false,
  disabled = false,
  label = '',
  image = ASSETS.LOADER,
  handleClick,
  marginTop = '24px',
  position = '',
  bottom = '',
  width = '',
  marginLeft = '',
  secondary = false,
}) => {
  const Button = secondary ? SecondaryButton : PrimaryButton;
  const styles = secondary
    ? {}
    : {
        border: '1px solid rgb(15, 164, 87)',
        borderRadius: '8px',
        background: 'rgb(15, 164, 87)',
      };

  return (
    <ButtonContainer
      marginLeft={marginLeft}
      marginTop={marginTop}
      position={position}
      bottom={bottom}
      width={width}
      styles={disabled || Button === PrimaryButton ? {} : styles}
    >
      <ButtonLoaderImage
        src={image}
        marginTop={marginTop}
        visibility={isLoading}
      />
      <Button
        isFullWidth
        onClick={handleClick}
        disabled={disabled}
        className="secondary-button"
      >
        <ButtonText padding={'4px 0px'} hide={isLoading}>
          {parse(label)}
        </ButtonText>
      </Button>
    </ButtonContainer>
  );
};

export default Index;
